module.exports = __webpack_public_path__ + "static/media/2-stars_icon.003fcf84.svg";